import { render, staticRenderFns } from "./SzechenyiPlanPlus.vue?vue&type=template&id=800083ac&scoped=true&"
import script from "./SzechenyiPlanPlus.vue?vue&type=script&lang=js&"
export * from "./SzechenyiPlanPlus.vue?vue&type=script&lang=js&"
import style0 from "./SzechenyiPlanPlus.vue?vue&type=style&index=0&id=800083ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800083ac",
  null
  
)

export default component.exports